module.exports = __webpack_public_path__ + "static/media/RBD_Logo.dd779b85.png";